var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcTouchId(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 35,
    r: 35,
    fill: "#FFDCE3",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#F7465F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M14.11 73A30.94 30.94 0 1 1 48 73M29 78a51.48 51.48 0 0 0 1.82-7 65 65 0 0 0 1-14A53.51 53.51 0 0 0 31 47"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#F7465F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M37 40.16a8.46 8.46 0 0 0-1-.82C34 38 31.44 37.41 28 38c-14.5 5.75 1.42 20.25-7.35 38M38.65 76c1.4-6.48 4-19.91 1.82-29M14 54c3 7.38 1.54 12.5.1 19"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#F7465F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M49 59c4.25-20.42-7.6-29.84-18-30-9.42-.15-18.29 7.92-18 17"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTouchId);
export default __webpack_public_path__ + "static/media/ic-touch-id.c8f7ea9339c6c6f6273bca4dd1915427.svg";
export { ForwardRef as ReactComponent };